module.exports = __webpack_public_path__ + "img/hero-icon-ball-3.d48f0b32.svg";